import React, { ReactElement, Fragment, useState } from 'react';
import { Collapse, Checkbox, Chip } from '@material-ui/core';
import { ListAltRounded } from '@material-ui/icons';
import { isIosMobile, isMobile } from '../../../utils/app.helper';
type Props={
    className?: string;
    id?: string;
};

type BlockProps ={
    className?: string;
    id?: string;
    toggle: boolean;
};

type CheckboxProps ={
    label: string;
    onChange: (value: boolean) => void;
    defaultChecked?: boolean;
};

type FilterButtonProps ={
    onClick: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

const Sidebar: React.FC<Props> = ({ children, className = '', id }): ReactElement => {
    return (
        <div id='bv-sidebar' className={`bv-sidebar ${className}`}>
            {children}
        </div>
    );
};

const SidebarContent: React.FC<Props> = ({ children, className = '', id }): ReactElement => {
    let height = '100%';

    if (!isMobile()) {
        const objListHeader = document.getElementById('bv-object-list-wrapper');
        const siteMap = document.getElementById('bv-sitemap-container');
        const sumHeight = (objListHeader?.clientHeight || 0) + (siteMap?.clientHeight || 0);

        height = `calc(100% - ${sumHeight}px)`;
    }

    return (
        <div className={`bv-sidebar-content ${className}`} style={{ height }} id={id}>
            {children}
        </div>
    );
};


const SidebarCollapsableBlock: React.FC<BlockProps> = ({ children, className = '', toggle }): ReactElement => {
    return (
        <Collapse in={toggle} timeout={5} unmountOnExit className={`bv-sidebar-collapsable-block ${className}`}>
            {children}
        </Collapse>
    );
};

const SidebarFilterBlock: React.FC<Props> = ({ children, className = '' }): ReactElement => {
    return (
        <div className={`bv-sidebar-filter-block ${className}`}>
            {children}
        </div>

    );
};

const SidebarFilterCheckbox: React.FC<CheckboxProps> = ({ label, onChange, defaultChecked = false }): ReactElement => {
    const [checked, setChecked] = useState(defaultChecked);

    return (
        <Chip className={'bv-sidebar-filter-block-chip'}
            label={label}
            style={{ backgroundColor: checked ? '#008761' : 'white', border: '1px solid', borderColor: checked ? '#f1f1f1' : '#008761', color: checked ? 'white' : 'black' }}
            variant={checked ? undefined : 'outlined'} onClick={() => {
                onChange(!checked);
                setChecked(!checked);
            }}/>
    );
};

const SidebarFilterButton: React.FC<FilterButtonProps> = ({ onClick }): ReactElement => {
    return (
        <ListAltRounded onClick={onClick}/>
    );
};

export { Sidebar, SidebarContent, SidebarCollapsableBlock, SidebarFilterBlock, SidebarFilterCheckbox, SidebarFilterButton };